import { render, staticRenderFns } from "./createNewImageText.vue?vue&type=template&id=04799ec2&"
import script from "./createNewImageText.vue?vue&type=script&lang=ts&"
export * from "./createNewImageText.vue?vue&type=script&lang=ts&"
import style0 from "./createNewImageText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports